import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCCGu1XVAWvpgqePyUD8G3vQ6IxW3Y9EGI",
  authDomain: "myportfolio-b44ae.firebaseapp.com",
  projectId: "myportfolio-b44ae",
  storageBucket: "myportfolio-b44ae.appspot.com",
  messagingSenderId: "264642575424",
  appId: "1:264642575424:web:0cf72950c9c308507673a5",
};

export const app = initializeApp(firebaseConfig);
